import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=73c94a44&scoped=true&"
import script from "./BaseContainer.vue?vue&type=script&lang=js&"
export * from "./BaseContainer.vue?vue&type=script&lang=js&"
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=73c94a44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c94a44",
  null
  
)

export default component.exports